import { SocialProvider } from '../../components/SocialButton/constants';

export type NavigationFlowType =
    | 'order_started'
    | 'seller'
    | 'start_selling'
    | 'cookie_redirect'
    | 'sso'
    | 'oauth_sso'
    | 'instant_token'
    | 'vanilla_api'
    | 'facebook_campaign'
    | 'unbounce'
    | 'guest_buyer_request'
    | 'return_to'
    | 'root'
    | 'default';

export type AuthenticationFlowName = 'registration' | 'sign_in' | 'silent_association' | 'association';

export interface AuthenticationFlowType {
    name: AuthenticationFlowName;
    eventName: string;
}

export const AUTHENTICATION_FLOW_TYPE_MAP: Record<string, AuthenticationFlowType> = {
    signUp: {
        name: 'registration',
        eventName: 'Social Sign Up',
    },
    signIn: {
        name: 'sign_in',
        eventName: 'Sign In',
    },
    silentAssociation: {
        name: 'silent_association',
        eventName: 'Silent Association',
    },
    association: {
        name: 'association',
        eventName: 'Association',
    },
};

export const AUTHENTICATION_SIGN_IN_FLOW_TYPES = [
    AUTHENTICATION_FLOW_TYPE_MAP.signIn,
    AUTHENTICATION_FLOW_TYPE_MAP.silentAssociation,
];

export type AuthenticationStatus = 'success' | 'failure';
export interface SocialUserData {
    exists_by_email: boolean;
    provider_name: SocialProvider;
    provider_uid: string;
    suggested_email: string;
    suggested_username: string;
    user_social_name: string;
    user_social_photo: string;
}

export interface AuthenticationResponse {
    callback: string;
    provider: SocialProvider;
    result_hash: {
        status: AuthenticationStatus;
        flow_type: AuthenticationFlowName;
        user_data?: Partial<SocialUserData>;
        error?: string;
    };
    url: string;
    guest_checkout: Record<string, unknown>;
    navigation_flow: NavigationFlowType;
}

export interface AuthenticationPostMessagePayload {
    name: string;
    response: AuthenticationResponse;
}
